var _path, _g, _path2, _g2, _path3, _path4, _path5, _g3, _path6, _g4, _path7, _g5, _path8, _g6, _path9, _g7, _g8, _path0, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmptyState = function SvgEmptyState(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 160 109",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#empty-state_svg__clip0_6643_19288)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#empty-state_svg__clip1_6643_19288)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#empty-state_svg__clip2_6643_19288)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "empty-state_svg__a",
    style: {
      maskType: "luminance"
    },
    width: 198,
    height: 199,
    x: -19,
    y: -44,
    maskUnits: "userSpaceOnUse"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-18.666-43.165h197.333v197.333H-18.666V-43.165z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    mask: "url(#empty-state_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 88.359c43.97 0 79.614 3.002 79.614 6.707S123.97 101.773 80 101.773c-43.969 0-79.613-3.002-79.613-6.707S36.03 88.36 80 88.36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 86.803v.098c0 .777-.583 1.36-1.36 1.36H74.265c-.778 0-1.361-.583-1.361-1.36v-.098H6.9v1.847c0 3.014 6.708 4.666 10.207 4.666h125.691c3.499 0 10.207-1.555 10.207-4.666v-1.847H87z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9 86.803h146.105v1.847H6.9v-1.847z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.626 87.97h8.652c.583 0 1.07-.485 1.07-1.069H74.653c0 .584.486 1.07 1.07 1.07h-.098zM26.73 8.843h107.415a3.5 3.5 0 013.5 3.5v69.6a3.5 3.5 0 01-3.5 3.5H26.73a3.5 3.5 0 01-3.5-3.5v-69.6a3.5 3.5 0 013.5-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.73 10.495a1.95 1.95 0 00-1.944 1.945v69.6a1.95 1.95 0 001.945 1.945h107.415a1.95 1.95 0 001.944-1.944V12.44a1.95 1.95 0 00-1.944-1.945H26.731zm107.416 76.6H21.676V12.44c0-2.82 2.333-5.055 5.055-5.055h107.415c2.819 0 5.055 2.333 5.055 5.055V86.9s-2.333.195-5.055.195z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.057 8.842h18.76v2.819c0 1.07-.874 1.847-1.846 1.847H73a1.846 1.846 0 01-1.847-1.847V8.84h-.097z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.613 10.494v1.264c0 .194.097.292.291.292h14.97c.195 0 .292-.098.292-.292v-1.264H72.613zm15.359 4.666h-14.97a3.485 3.485 0 01-3.5-3.5V8.843c0-.875.68-1.556 1.555-1.556h18.761c.875 0 1.556.68 1.556 1.556v2.819c0 1.944-1.555 3.5-3.5 3.5h.098zM67.752 19.729l-1.166 2.625h.486l.292-.68h1.166l.292.68h.486l-1.167-2.625h-.389zm.195.583l.389.972h-.875l.389-.972h.097z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "empty-state_svg__b",
    style: {
      maskType: "luminance"
    },
    width: 28,
    height: 6,
    x: 66,
    y: 18,
    maskUnits: "userSpaceOnUse"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M66.586 23.229h26.636v-5.152H66.586v5.151z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    mask: "url(#empty-state_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.057 22.354h-.389v-.195c-.097.195-.291.195-.486.195-.486 0-.68-.292-.68-.778v-1.167h.389v1.07c0 .291.194.486.389.486.194 0 .388-.098.388-.292V20.41h.39v1.945zM74.557 20.507h.388v.291c0-.097.292-.291.487-.291h.194v.388h-.195c-.194 0-.388 0-.486.292v1.166h-.388v-1.846zM76.599 22.062a.535.535 0 00.486-.291v-.68a.534.534 0 00-.486-.292c-.194 0-.583.291-.583.583 0 .291.194.583.583.583m0 .486a.974.974 0 01-.972-.972c0-.486.389-.972.972-.972s.389 0 .583.194v-.194h.39v1.847h-.39v-.194c-.097.097-.291.194-.583.194M77.861 19.826l.486-.486v3.014h-.486v-2.528zM78.639 20.507h.388v1.846h-.388v-1.846zm.29-.292c-.193 0-.29-.097-.29-.292 0-.194.097-.291.29-.291.195 0 .292.097.292.291 0 .195-.097.292-.291.292zM80.39 22.062a.535.535 0 00.486-.291v-.68a.534.534 0 00-.486-.292c-.195 0-.584.291-.584.583 0 .291.195.583.584.583m-.098.486a.974.974 0 01-.972-.972c0-.486.39-.972.972-.972.584 0 .39 0 .584.194v-.194h.388v1.847h-.388v-.194c-.098.097-.292.194-.584.194M81.652 20.507h.39v.194c.096-.194.29-.194.582-.194.487 0 .778.292.778.778v1.166h-.389v-1.07c0-.29-.194-.485-.389-.485a.534.534 0 00-.486.291v1.264h-.388v-1.847l-.098-.097zM84.084 21.674c.097.194.389.388.583.388.195 0 .39-.097.39-.291 0-.195-.098-.292-.39-.39h-.291c-.39-.29-.584-.485-.584-.874s.39-.778.875-.778c.486 0 .584.098.778.39l-.292.29a.535.535 0 00-.486-.29c-.194 0-.388.096-.388.29 0 .195.097.292.388.39h.292c.389.291.583.486.583.875 0 .486-.389.777-.875.777s-.777-.194-.972-.486l.39-.291zM87.485 22.354h-.389v-.195c-.097.195-.291.195-.486.195-.486 0-.68-.292-.68-.778v-1.167h.388v1.07c0 .291.195.486.39.486.194 0 .388-.098.388-.292V20.41h.389v1.945zM88.75 22.062c.291 0 .583-.292.583-.583 0-.39-.389-.68-.68-.584-.195 0-.292.098-.39.195v.68a.535.535 0 00.487.292zm-.875-1.555h.389v.194c.097-.097.291-.194.583-.194.583 0 .972.486.972.972a.974.974 0 01-.972.972c-.583 0-.389 0-.583-.195v.973h-.389v-2.722zM92.152 20.507h.39v.291c0-.097.29-.291.485-.291h.195v.388h-.195c-.194 0-.389 0-.486.292v1.166h-.389v-1.846zM72.223 21.285h-.194c-.195-.098-.195-.195-.195-.292 0-.097.097-.194.292-.194.194 0 .291 0 .389.194l.291-.292c-.097-.194-.389-.291-.583-.291-.389 0-.68.194-.68.583 0 .292.194.486.486.583h.194c.194.098.292.195.292.292 0 .097-.098.194-.292.194-.194 0-.389 0-.486-.291l-.292.291c.098.195.39.39.68.39.292 0 .681-.195.681-.584 0-.389-.194-.486-.486-.583M74.168 21.965h-.292c-.195 0-.292 0-.292-.292v-.875h.584v-.389h-.584v-.68h-.389v.68h-.388v.39h.388v.971c0 .39.292.584.68.584h.293v-.39zM90.888 20.798c.195 0 .487.195.487.389h-1.07c0-.292.292-.389.583-.389zm.584.972a.742.742 0 01-.486.195c-.195 0-.584-.195-.584-.486h1.459v-.098c0-.583-.39-.972-.875-.972a.974.974 0 00-.972.972c0 .584.486.973 1.069.973.292 0 .583-.195.68-.39l-.291-.194z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M81.75 18.465v.097l1.847.39c.097-.39.194-.681-.097-.681l-1.75.194z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M83.403 18.075c.291.195.291.486.097.875l-.486 1.07s0 .096.097 0l1.944-1.945h-1.653z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "empty-state_svg__c",
    style: {
      maskType: "luminance"
    },
    width: 198,
    height: 199,
    x: -19,
    y: -44,
    maskUnits: "userSpaceOnUse"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-18.666-43.165h197.333v197.333H-18.666V-43.165z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    mask: "url(#empty-state_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.363 77.178h11.082c.751 0 1.36.587 1.36 1.312 0 .726-.609 1.313-1.36 1.313H74.363c-.751 0-1.361-.587-1.361-1.313 0-.725.61-1.312 1.36-1.312zM89.278 28.477h10.319c.426 0 .772.587.772 1.312 0 .725-.346 1.313-.772 1.313H89.278c-.426 0-.772-.588-.772-1.313s.346-1.312.772-1.312zM89.168 32.075h27.644c.366 0 .662.522.662 1.166v.292c0 .644-.296 1.166-.662 1.166H89.168c-.366 0-.662-.522-.662-1.166v-.292c0-.644.296-1.166.662-1.166zM89.168 35.67h27.644c.366 0 .662.522.662 1.167v.291c0 .645-.296 1.167-.662 1.167H89.168c-.366 0-.662-.522-.662-1.167v-.291c0-.645.296-1.167.662-1.167zM89.168 39.366h27.644c.366 0 .662.522.662 1.166v.292c0 .644-.296 1.166-.662 1.166H89.168c-.366 0-.662-.522-.662-1.166v-.292c0-.644.296-1.166.662-1.166zM89.168 42.961h27.644c.366 0 .662.522.662 1.167v.291c0 .645-.296 1.167-.662 1.167H89.168c-.366 0-.662-.522-.662-1.167v-.291c0-.645.296-1.167.662-1.167zM123.866 99.731c9.865 0 17.862 1.469 17.862 3.281s-7.997 3.281-17.862 3.281c-9.865 0-17.862-1.469-17.862-3.281s7.997-3.28 17.862-3.28zM89.278 48.502h10.319c.426 0 .772.587.772 1.313 0 .725-.346 1.312-.772 1.312H89.278c-.426 0-.772-.587-.772-1.312 0-.725.346-1.313.772-1.313zM89.168 52.1h27.644c.366 0 .662.522.662 1.166v.292c0 .645-.296 1.167-.662 1.167H89.168c-.366 0-.662-.522-.662-1.167v-.291c0-.645.296-1.167.662-1.167zM89.168 55.793h27.644c.366 0 .662.522.662 1.167v.291c0 .645-.296 1.167-.662 1.167H89.168c-.366 0-.662-.522-.662-1.166v-.292c0-.645.296-1.167.662-1.167zM89.168 59.389h27.644c.366 0 .662.522.662 1.166v.292c0 .645-.296 1.167-.662 1.167H89.168c-.366 0-.662-.522-.662-1.167v-.291c0-.645.296-1.167.662-1.167zM89.168 63.084h27.644c.366 0 .662.522.662 1.167v.291c0 .645-.296 1.167-.662 1.167H89.168c-.366 0-.662-.522-.662-1.166v-.292c0-.645.296-1.167.662-1.167z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.551 48.643l20.863 4.702a2.43 2.43 0 011.836 2.904l-10.365 45.994a2.432 2.432 0 01-2.905 1.836l-20.863-4.702a2.429 2.429 0 01-1.836-2.905l10.365-45.993a2.43 2.43 0 012.905-1.836z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M132.746 105.123a3.5 3.5 0 004.183-2.645l10.365-45.992a3.5 3.5 0 00-2.644-4.184m0 0L123.787 47.6a3.499 3.499 0 00-4.183 2.645l-10.365 45.993a3.5 3.5 0 002.644 4.183l20.863 4.702m.47-2.087l-20.863-4.701a1.36 1.36 0 01-1.028-1.626l10.365-45.994a1.36 1.36 0 011.626-1.028l20.864 4.702a1.36 1.36 0 011.028 1.626l-10.365 45.993a1.362 1.362 0 01-1.627 1.028z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.396 49.515l12.424 2.8-.428 1.896a1.287 1.287 0 01-1.511.955l-9.957-2.243a1.286 1.286 0 01-.955-1.511l.427-1.897z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "empty-state_svg__d",
    style: {
      maskType: "luminance"
    },
    width: 11,
    height: 6,
    x: 119,
    y: 71,
    maskUnits: "userSpaceOnUse"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M119.371 71.93l9.04 4.375c1.167-1.653 1.556-3.208.292-3.889l-9.138-1.263c-.486 0-.583.583-.194.777z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#empty-state_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M116.904 72.021l7.965-6.067 6.597 8.66-7.964 6.068-6.598-8.66z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "empty-state_svg__e",
    style: {
      maskType: "luminance"
    },
    width: 198,
    height: 199,
    x: -19,
    y: -44,
    maskUnits: "userSpaceOnUse"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-18.666-43.165h197.333v197.333H-18.666V-43.165z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#empty-state_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M137.353 73.583l-8.554-1.167c1.166.68.778 2.236-.292 3.889l-3.985 5.152c-.292.389.097.778.486.583l12.54-7.68c.291-.194.194-.68-.098-.68"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "empty-state_svg__f",
    style: {
      maskType: "luminance"
    },
    width: 14,
    height: 11,
    x: 124,
    y: 72,
    maskUnits: "userSpaceOnUse"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M128.507 76.305l-3.985 5.152c-.292.389.097.778.486.583l12.54-7.68c.291-.194.194-.68-.098-.68l-.097-.097-8.554-1.167c1.166.68.778 2.236-.292 3.889z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#empty-state_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M123.078 81.746l3.724-11.669 11.946 3.813-3.724 11.669-11.946-3.813z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "empty-state_svg__g",
    style: {
      maskType: "luminance"
    },
    width: 198,
    height: 199,
    x: -19,
    y: -44,
    maskUnits: "userSpaceOnUse"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-18.666-43.165h197.333v197.333H-18.666V-43.165z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#empty-state_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M120.325 94.446l7.492 1.689a.874.874 0 11-.385 1.707l-7.492-1.689a.875.875 0 01.385-1.707z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#empty-state_svg__clip3_6643_19288)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M130.285 69.05l4.669 3.1-.927 4.003a8.494 8.494 0 01-1.223 2.805l.989 1.584a10.188 10.188 0 001.938-3.994l1.201-5.189-6.225-4.133-4.833.641 1.015 1.626 3.396-.444zm-7.567-2.945l-1.488.921 1.709 2.738-.839 3.63c-.996 4.302.981 8.987 4.665 10.871 1.55-.027 3.062-.512 4.393-1.335l2.115 3.389 1.479-.924-12.034-19.29zm4.457 16.388c-2.717-1.642-4.162-5.289-3.371-8.705l.445-1.926 5.985 9.59c-.94.571-1.988.948-3.059 1.041z"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M55.275 36.062l8.75 3.28v6.854c0 1.735-.336 3.441-.934 5.016l2.202 2.201c1.05-2.23 1.647-4.695 1.647-7.217v-8.88L55.276 32.94 47.664 35.8l2.26 2.26 5.351-1.997zm-13.4-1.94l-2.07 2.056 3.805 3.806v6.212c0 7.363 4.973 14.231 11.665 15.908 2.508-.627 4.783-1.983 6.635-3.82l4.71 4.71 2.056-2.056-26.8-26.816zm13.4 24.95c-5.03-1.649-8.748-7.03-8.748-12.876V42.9l13.327 13.328c-1.312 1.283-2.873 2.289-4.579 2.843z"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "empty-state_svg__clip0_6643_19288"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h160v109H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "empty-state_svg__clip1_6643_19288"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h160v109.333H0z",
    transform: "translate(0 .334)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "empty-state_svg__clip2_6643_19288"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h160v110.667H0z",
    transform: "translate(0 -.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "empty-state_svg__clip3_6643_19288"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20.987v20.987H0z",
    transform: "rotate(13.028 -216.98 558.043)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty-state_svg__paint0_linear_6643_19288",
    x1: 52.783,
    x2: 54.097,
    y1: 54.32,
    y2: 52.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty-state_svg__paint1_linear_6643_19288",
    x1: 231.497,
    x2: 234.385,
    y1: 32.025,
    y2: 32.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyState);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/empty-state.00e77ad1d558e6aedac7a0452c10b617.svg";